module.exports = __webpack_public_path__ + "img/1.6e2ed5ef.jpg";